import axios from "axios";
import * as localforage from "localforage";
import { nubisUrl } from "./apiSetup";
import { t } from "../langs/useTranslation";
import { toast } from "@/helpers/toast";
import { errorHandling } from "../helpers/errorHandling";
import PlatFormLoading from "@/components/loading"; // 公共进度条
// 全局loading
let requestCount = 0;
const showLoading = () => {
  if (requestCount <= 0) {
    PlatFormLoading.show();
  }
  requestCount++;
};

const hideLoading = () => {
  try {
    requestCount = Math.max(0, requestCount - 1); // 确保 requestCount 不会小于 0
    if (requestCount === 0) {
      PlatFormLoading.hide();
    }
  } catch (e) {
    console.log(e);
  }
};

export function getErrorMsg(code) {
  const ERROR_CODE_MSG = {
    0: t({ defaultMessage: "未知错误" }),
    30000: t({ defaultMessage: "参数错误" }),
    40000: t({ defaultMessage: "用户没有绑定邮箱，无法进行验证" }),
    40001: t({ defaultMessage: "请勿频繁发送验证码！" }),
    40002: t({ defaultMessage: "验证失败" })
  };
  return ERROR_CODE_MSG[code];
}

export const nubisGorequest = axios.create({
  // baseURL: nubisUrl
});

const origHttpGet = nubisGorequest.get;

// 重写get方法，保持跟post方法传参一致
nubisGorequest.get = (url, params, config) => {
  return origHttpGet(url, { params, ...config });
};

nubisGorequest.interceptors.request.use(
  async config => {
    if (config.showLoading) {
      showLoading();
    }
    const token = await localforage.getItem("token");
    const lang = localStorage.getItem("rcml-lang");
    config.baseURL = nubisUrl;
    // config.headers.Authorization = "Bearer FIXME:a-secret-token"; // token || "";
    config.headers.Accept = "application/json";
    config.headers.AcceptLanguage = lang || "en";
    config.headers.Authorization = "Bearer " + token;
    //config.withCredentials = true;
    return config;
  },
  error => {
    PlatFormLoading.hide();
    return Promise.reject(error);
  }
);

nubisGorequest.interceptors.response.use(
  response => {
    if (response.config.showLoading) {
      hideLoading();
    }
    const { data } = response;
    if (data.code) {
      const err = new Error(
        getErrorMsg(data.code) || data.message || "unknown error"
      );
      err.code = data.code;
      toast.error(err.message);
      return Promise.reject(err);
    }
    return data;
  },
  err => {
    hideLoading();
    if (err.name !== "CanceledError") {
      console.error(err);
    }
    errorHandling(err);
    return Promise.reject(err);
  }
);
